interface calTotalShipmentProps {
  duration: number | undefined;
  frequency: number | undefined;
}
export const calTotalShipment = (props: calTotalShipmentProps): number => {
  const { duration, frequency } = props;

  if (duration === undefined || frequency === undefined) {
    return 0;
  }

  const numDuration = Number(duration);
  const numFrequency = Number(frequency);

  return numDuration * numFrequency;
};

interface calTotalBeansProps {
  boxGrams: number | undefined;
  totalShipment: number | undefined;
}
export const calTotalBeans = (props: calTotalBeansProps): number => {
  const { boxGrams, totalShipment } = props;

  if (boxGrams === undefined || totalShipment === undefined) {
    return 0;
  }

  return totalShipment * boxGrams;
};

export const formatWeight = (n: number): string => {
  return n.toLocaleString(undefined, {
    minimumFractionDigits: Number.isInteger(n) ? 0 : 2,
    maximumFractionDigits: Number.isInteger(n) ? 0 : 2,
  });
};

interface HumanWeightProps {
  grams: number | undefined;
}
interface HumanWeightReturn {
  unit: "g" | "kg";
  value: number;
}

// Function overloads for precise return typing
export function humanWeight(props: { grams: number }): HumanWeightReturn;
// eslint-disable-next-line no-redeclare
export function humanWeight(props: { grams: undefined }): undefined;
// eslint-disable-next-line no-redeclare
export function humanWeight(props: HumanWeightProps): HumanWeightReturn | undefined;
// eslint-disable-next-line no-redeclare, func-style
export function humanWeight(props: HumanWeightProps): HumanWeightReturn | undefined {
  const { grams } = props;

  if (grams === undefined) {
    return undefined;
  }

  if (Math.abs(grams) >= 1000) {
    const kg = grams / 1000;
    return {
      unit: "kg",
      value: kg,
    };
  }

  return {
    unit: "g",
    value: grams,
  };
}

export const humanWeightStr = (props: HumanWeightProps): string => {
  const w = humanWeight(props);
  if (!w) {
    return "";
  }

  const { unit, value } = w;
  return `${formatWeight(value)}${unit}`;
};

// Function overloads for precise return typing
export function extractVariantBoxSize(v: string): number;
// eslint-disable-next-line no-redeclare
export function extractVariantBoxSize(v: undefined): undefined;
// eslint-disable-next-line no-redeclare
export function extractVariantBoxSize(v: string | undefined): number | undefined;
// eslint-disable-next-line no-redeclare, func-style
export function extractVariantBoxSize(v: string | undefined): number | undefined {
  if (!v) {
    return undefined;
  }
  const match = v.match(/(\d+)g/);
  if (!match) {
    throw new Error(`Invalid variant box size: ${v}`);
  }
  return Number(match[1]);
}

// Function overloads for precise return typing
export function extractFrequencyPerMonth(v: string): number;
// eslint-disable-next-line no-redeclare
export function extractFrequencyPerMonth(v: undefined): undefined;
// eslint-disable-next-line no-redeclare
export function extractFrequencyPerMonth(v: string | undefined): number | undefined;
// eslint-disable-next-line no-redeclare, func-style
export function extractFrequencyPerMonth(v: string | undefined): number | undefined {
  if (!v) {
    return undefined;
  }
  const match = v.match(/(\d+) per month/);
  if (!match) {
    throw new Error(`Invalid variant frequency per month: ${v}`);
  }
  return Number(match[1]);
}

// Function overloads for precise return typing
export function extractSubscriptionDuration(v: string): number;
// eslint-disable-next-line no-redeclare
export function extractSubscriptionDuration(v: undefined): undefined;
// eslint-disable-next-line no-redeclare
export function extractSubscriptionDuration(v: string | undefined): number | undefined;
// eslint-disable-next-line no-redeclare, func-style
export function extractSubscriptionDuration(v: string | undefined): number | undefined {
  if (!v) {
    return undefined;
  }
  const match = v.match(/(\d+) month/);
  if (!match) {
    throw new Error(`Invalid variant subscription duration: ${v}`);
  }
  return Number(match[1]);
};
